export default "__VITE_PUBLIC_ASSET__ace74f14__"